import axios from 'axios';
import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import constants from 'constants';
import actions from 'actions';
import { toast } from 'react-toastify';
import { push } from 'redux-router';
import validator from 'services/validator.js';

const {
  addErrorsSaga,
  addValidateError
} = actions;

const {
  NEW_PASSWORD_SAGA,
  API_NEW_PASSWORD
} = constants;

const apiNewPassword = (user) => (
  axios.put(API_NEW_PASSWORD, {
    user
  })
);

function* newPassword({ user }) {
  try {
    const errors = validator.validate(user, 'newPassword');
    if (errors) {
      yield put(addValidateError(NEW_PASSWORD_SAGA, errors));
      return;
    }
    const response = yield call(apiNewPassword, user);
    yield call(toast.success, response.data.message);
    yield put(push('/'));
  } catch (e) {
    yield put(addErrorsSaga(NEW_PASSWORD_SAGA, e.response))
  }
}

function* __newPasswordSaga() {
  yield takeLatest(NEW_PASSWORD_SAGA, newPassword)
}

export {
  __newPasswordSaga
};



// WEBPACK FOOTER //
// ./src/sagas/newPassword.js